import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge54 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='「紹介者」と「推薦人」の違い' fontWeight={700} />
                <p>
                    ゴルフ会員権の入会にあたって「紹介者」という言葉が使われますが、必ずしも
                    <a href='/knowledge/18'>推薦状</a>
                    を書く「推薦人」と同一人物とは限りません。知人がゴルフ場や会員権業者を教えてくれただけの場合もあれば、推薦人として書類上の手続きまで担ってくれる場合もあります。
                    <br />
                    本記事では、推薦状の御礼とは別に、日頃お世話になった紹介者に対する一般的なお礼のマナーをご紹介します。推薦状を書いていただいた場合の御礼状の文例・謝礼の内容については
                    <a href='/knowledge/18'>推薦状の文例</a>
                    で詳しく解説しています。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='お礼を伝えるタイミング' fontWeight={700} />
                <p>
                    紹介を受けた直後、無事に入会が決まった時点、実際に一緒にラウンドする機会があった時など、お礼を伝える機会は一度とは限りません。特に入会が正式に決まった段階では、経過報告を兼ねて必ず一報を入れましょう。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='お礼の方法' fontWeight={700} />

                <Heading3 title='品物や会食で気持ちを伝える' />
                <p>
                    相手との関係性に応じて、食事へお誘いする、ゴルフ用品やお酒・お菓子などの品物を贈るといった方法が一般的です。金額の相場や品物の選び方に迷う場合は、会員やゴルフ会員権業者に確認しておくと安心です。
                </p>

                <Heading3 title='ラウンドへ招待する' />
                <p>
                    入会後、紹介してくれた相手を自分のゲストとしてラウンドに招待するのも喜ばれる方法です。紹介のおかげで入会できたことへの感謝を、実際にゴルフを楽しむ形で示せます。
                </p>

                <Heading3 title='継続的な気配りを忘れない' />
                <p>
                    お礼は入会時の一度きりで終わらせず、その後もお中元・お歳暮のような季節の挨拶や、クラブ内で顔を合わせた際の気配りなど、継続的な関係を大切にすることが望まれます。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='マナーとして気をつけたいこと' fontWeight={700} />
                <p>
                    紹介者の顔を立てる振る舞いも重要です。クラブ内で紹介者の評判に関わるような言動（マナー違反や予約枠の独占など）は慎み、紹介者に恥をかかせないよう心がけましょう。
                    <br />
                    また、紹介者本人が推薦人として名を連ねている場合、名義書換や退会時の手続きにも紹介者の信用が関わることがあるため、日頃から誠実な会員としての姿勢を保つことが結果的に最大のお礼になります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    紹介者へのお礼は、金銭や品物だけでなく、入会後の振る舞いや継続的な気配りを通じて示すことが大切です。推薦状を書いていただいた推薦人への具体的な御礼状の文例・謝礼内容は
                    <a href='/knowledge/18'>推薦状の文例</a>
                    をご覧ください。
                    <br />
                    ご購入・ご売却の際にはゴルフ会員権の売買実績を有する住地ゴルフにまずはご相談ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge54;
